// an apiClient wrapper for endpoints that requires authentication but not tenant selection

export function createAuthApi(apiClient) {
  return function authApi(path, options = {}) {
    return apiClient(path, {
      headers: {}, // extract headers if given. otherwise use empty object
      query: {}, // extract query params if given. otherwise use empty object
      method: "GET", // default to GET method if not set
      ...options, // spread other options
      requireAuth: true, // explicitly set to true (override any given option)
      requireTenant: false, // explicitly set to false (override any given option)
    });
  };
}
